import TokenAnalyzerWalletStatsUpgrade from "./TokenAnalyzerWalletStatsUpgrade";

export default TokenAnalyzerWalletStatsUpgrade;